import script from "./BulkStatementPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkStatementPanel.vue?vue&type=script&setup=true&lang=js"

import "./BulkStatementPanel.vue?vue&type=style&index=0&id=86acd190&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86acd190"]])

export default __exports__